export type HrProps = {
  className?: string;
};

export default function Hr({ className }) {
  return <div className={`h-[1px] w-full ${className}`} />;
}
